<template>
<div
  class="header__voice"
  :data-voice="data.namespace"
  data-mouse
  data-mouse-attractionState="active"
  data-mouse-attractionVal="30"
  data-mouse-magnetism="5"
  data-hover-type="fadeout"
  ref="voice"
>
  <transition
    @enter="transitionEnter"
    @leave="transitionLeave"
    mode="out-in"
  >
    <router-link
      :to="data.link"
      data-text
    >
      {{ data.voice }}
    </router-link>
  </transition>
</div>
</template>

<script>
import gsap from 'gsap';

const SplitText = require('../assets/lib/gsap/uncompressed/utils/SplitText'); // eslint-disable-line


export default {
  name: 'HeaderVoice',

  props: ['data', 'loaderIsOut'],

  watch: {
    loaderIsOut(newVal) {
      if (newVal) this.enterHeader();
    },
  },

  methods: {
    enterHeader() {
      const text = this.$refs.voice.querySelector('[data-text]');
      const split = new SplitText(text, { type: 'chars' });
      const tl = new gsap.TimelineMax({
        delay: 0.6,
        onComplete: () => {
          split.revert();
        },
      });

      tl.add('start')
        .staggerFrom(split.chars, 0.8, {
          yPercent: 20,
          autoAlpha: 0,
          ease: gsap.Power2.easeInOut,
        }, 0.01, 'start');
    },

    transitionEnter(el, done) {
      gsap.fromTo(el, 0.6, {
        autoAlpha: 0,
        yPercent: 20,
      }, {
        autoAlpha: 1,
        yPercent: 0,
        clearProps: 'all',
        delay: 1,
        onComplete: done,
      });
    },

    transitionLeave(el, done) {
      gsap.to(el, 0.6, {
        autoAlpha: 0,
        yPercent: 20,
        clearProps: 'all',
        onComplete: done,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';


.header__voice {
    display: inline-block;
    position: relative;

    &[data-voice="addFace"] {
      display: none;

      @include mq(sm) {
        display: inline-block;
      }
    }

    a {
      font-size: 1rem;
      display: inline-block;
      padding: 25px 0 25px 25px;
      transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);

      &:focus {
        outline: transparent;
      }

      @include mq(sm) {
        padding: 25px;
        font-size: .875rem;
      }
    }

    @at-root .pointerevents:not(.touchevents) &:hover a,
    .no-pointerevents.no-touchevents &:hover a {
      color: $color-blue;
    }

    a.router-link-exact-active {
      color: $color-blue;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderVoice.vue